


import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { Game } from '../../Components/Game/Game.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
export class Jackpot extends React.Component {

    constructor(props) {
        super(props);
        this.state = { jackpots: null, igre: null }


        this.setData = this.setData.bind(this);
        this.renderIgra = this.renderIgra.bind(this);


    }



    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);

        this.props.showLoadingFn(true);
        this.dataPromise = casino.utils.makeCancelablePromise(casino.repos.gameRepo.list().then(this.props.unpackGamesListFn));
        this.dataPromise.promise.then(this.setData, function (reason) { });
    }
    componentWillUnmount() {
        this.dataPromise.cancel();
        this.props.showLoadingFn(false);
    }
    setData(data) {

        var jackpotsAll = [];
        data.map(function (igra) {
            if (igra.jackpot) {
                var jackpots = igra.jackpots;
                var jackpot = Object.keys(igra.jackpots)[0];

                var jpIgra = { ...igra }; //novi es6 clone
                jpIgra.jpName = jackpots[jackpot];
                jpIgra.jpIznos = Number(jackpot);
                jackpotsAll.push(jpIgra);
            }
        });

        jackpotsAll = jackpotsAll.sort(function (i1, i2) { return i1.jpIznos < i2.jpIznos ? 1 : -1; });

        this.setState({
            jackpots: jackpotsAll,
            igre: data
        });
        this.props.showLoadingFn(false);
    }
    renderIgra(igra) {
        return <Game brands={this.props.brands} key={igra.sifra + igra.jpIznos.toString()} showJackpot={false} routePrefix="/jackpot" igra={igra} gameNameClass="text-center" />

    }
    render() {
        return <div>
            <Header key="header" {...this.state} {...this.props}></Header>

            <div id="page-wrapper" className="margin-center white no-padding">
                <div className="maximum">
                    <br />
                    <div>
                        <div className="clearfix games-container">
                            <div>
                                {
                                    this.state && this.state.jackpots ?
                                        this.state.jackpots.map(this.renderIgra) :
                                        <div>Dohvaćanje jackpota...<br /><br />&nbsp;<br /></div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <GameDetails {...this.props} {...this.state} routePrefix="/jackpot"></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>


    }
};
